import {
  RULE_CHAIN_ITEMS_PER_PAGE,
  type SecuritySchemaMergedState,
} from 'components/SecuritySchema/model/SecuritySchemaModel';
import { selectHighlightedRuleIndex } from './selectHighlightedRuleIndex';
import { selectHighlightedRuleOnCurrentPage } from './selectHighlightedRuleOnCurrentPage';

export const selectPaginatedHighlightedRuleIndex = (
  state: SecuritySchemaMergedState,
): number | null =>
  selectHighlightedRuleOnCurrentPage(state)
    ? selectHighlightedRuleIndex(state)! % RULE_CHAIN_ITEMS_PER_PAGE
    : null;
